module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACzSURBVEhL3dBLDoIwFIXh7kEnbFMduTDHuCwdVM9tfzDVNPTlhC9poPdxQnD79irEeD32NzE+Drn///JvrG9jvhrr5dgb94/J60bcL/rdiKvHflsAu8MQ+0F9GGL7kFUXxk7Ce3+lvbIa7QTtPOYSCpusp+dd15n3KXZT1mum0Jsdrn34oEChF8orq9EOKJdjL1DYQ+ekc9D1qOdZ5xm7EWt9yBoTtiAzi7F25GQxtlvOvQFFhQz2DCLfpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-hive/light/24.png
// module id = 2146
// module chunks = 2